"use strict";Object.defineProperty(exports, "__esModule", {value: true});// The GCS resumable upload protocol, as the direct-upload clients use it.
// https://cloud.google.com/storage/docs/performing-resumable-uploads

// Public errors from StartUpload that mean "use /upload_file instead": the
// kill switch is off, or the server predates direct uploads.
const FALLBACK_ERRORS = new Set(['direct upload disabled', 'command not found'])

// The patient transport answers an unknown command with `unauthorized
// command`, as it does a real authorization failure, so that one falls back
// without switching direct uploads off for a while.
 const isUnknownPatientCommand = (err) =>
  !!err && typeof err === 'object' &&
  (err ).Status === 'unauthorized' &&
  [undefined, 'unauthorized command'].includes((err ).Error ); exports.isUnknownPatientCommand = isUnknownPatientCommand

 const isDirectUploadDisabled = (err) => {
  if (!err || typeof err !== 'object') return false
  const message = (err ).Error
  return typeof message === 'string' && FALLBACK_ERRORS.has(message)
}; exports.isDirectUploadDisabled = isDirectUploadDisabled

 const isDirectUploadUnavailable = (err) =>
  exports.isDirectUploadDisabled.call(void 0, err) || exports.isUnknownPatientCommand.call(void 0, err); exports.isDirectUploadUnavailable = isDirectUploadUnavailable

// `upload already received`: GCS has every byte; complete instead of
// uploading again.
 const isUploadAlreadyReceived = (err) =>
  !!err && typeof err === 'object' && (err ).Error === 'upload already received'; exports.isUploadAlreadyReceived = isUploadAlreadyReceived

// The offset to continue from, given the Range header of a 308 response.
// No header means GCS has persisted nothing yet.
 const nextOffsetFromRange = (range) => {
  if (!range) return 0
  const match = /^bytes=0-(\d+)$/.exec(range.trim())
  if (!match) throw new Error(`Unexpected Range header: ${range}`)
  return Number(match[1]) + 1
}; exports.nextOffsetFromRange = nextOffsetFromRange

 const contentRangeForChunk = (start, endInclusive, total) =>
  `bytes ${start}-${endInclusive}/${total}`; exports.contentRangeForChunk = contentRangeForChunk

 const contentRangeForStatusQuery = (total) => `bytes */${total}`; exports.contentRangeForStatusQuery = contentRangeForStatusQuery

// The next chunk from offset: chunkBytes long (a multiple of 256 KiB, as
// GCS requires for every chunk but the last) or the rest of the file.
 const nextChunk = (offset, chunkBytes, total) => {
  if (offset >= total) return null
  const end = Math.min(offset + chunkBytes, total) - 1
  return { start: offset, end, length: end - offset + 1 }
}; exports.nextChunk = nextChunk





 // transient: back off and query the offset again

 const classifySessionResponse = (status) => {
  if (status === 200 || status === 201 || status === 412) return 'complete'
  if (status === 308) return 'incomplete'
  // 400: a Content-Range GCS rejected kills the session. 404/410: expired.
  // 499: cancelled (DELETE).
  if (status === 400 || status === 404 || status === 410 || status === 499) return 'restart'
  return 'retry'
}; exports.classifySessionResponse = classifySessionResponse

// Exponential backoff for retries, capped; `attempt` starts at 0.
 const retryDelayMs = (attempt, baseMs = 2000, maxMs = 5 * 60000) =>
  Math.min(maxMs, baseMs * 2 ** Math.max(0, attempt)); exports.retryDelayMs = retryDelayMs
